import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class ValaszListItemDto extends IdentifiableDto {
	constructor() {
		super();
        /** @type {string} */
		this.betujel = null;
        /** @type {boolean} */
        this.helyes = null;
        /** @type {string} */
        this.szoveg = null;
		this.szovegPlaintext = null;
        /** @type {string} */
        this.magyarazat = null;
		this.magyarazatPlaintext = null;
	}

	/**
	 * @Parameter {string} betujel
	 * @Parameter {boolean} helyes
     * @Parameter {string} szoveg
	 * @Parameter {string} magyarazat
	 */
	setup(props) {
		super.setup(props);
		this.betujel = props.betujel;
        this.helyes = props.helyes;
        this.szoveg = props.szoveg;
		this.szovegPlaintext = props.szovegPlaintext;
        this.magyarazat = props.magyarazat;
		this.magyarazatPlaintext = props.magyarazatPlaintext;
		return this;
	}
}

export default ValaszListItemDto;
